// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2bakM","productName":"Table_productName__11zBG"};